import { RESORTS_WITHOUT_WE_SKI } from 'ots-constants';

export const isResortWithoutWeSki = (locale: string, resortId: string) => (
  RESORTS_WITHOUT_WE_SKI.some((resort) => resort.locale === locale && resort.resortId === resortId)
);
